const apiConfig = {
    //apiUrl: 'https://localhost:7291/api/',
   
    apiUrl: 'https://pp-api.off-ease.com/api/',
    apiKey: 'Lieda1002',
};

export default apiConfig;
